module.exports = __webpack_public_path__ + "static/media/development.0daa1134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/development.jpg
// module id = 27
// module chunks = 0